import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import {
  genericUnitField,
  ghgCategoryField,
  eeioModelKindField,
} from './common/sharedFields';
import { msg } from '@lingui/core/macro';
import { cloudProviderField } from './common/cloudFields';
import { cloudSpendField } from './common/cloudFields';

export const ceeCloudSpendMetadata = {
  displayName: msg({
    message: 'CEE Cloud Spend',
    context: 'Activity data schema name for CEE Cloud Spend',
  }),
  fields: {
    ...coreFields,
    ghg_category_id: ghgCategoryField,
    eeio_model_kind: eeioModelKindField,
    provider: cloudProviderField,
    quantity: cloudSpendField,
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
